import React from 'react';
import bemHelper from 'react-bem-helper';
import { Link } from 'react-scroll';
import Waypoint from 'react-waypoint';

import topbarAnalytics from '../../analytics/topbar';
import './styles.scss';

const bem = bemHelper({ prefix: 'toga-', name: 'tabs' });

class TopModule extends React.Component {

  constructor(props) {
    super(props);
    this.onCrossingTabs = this.onCrossingTabs.bind(this);
    this.state = {
      fixed: false,
    };
  }

  onCrossingTabs({ currentPosition }) {
    this.setState({ fixed: currentPosition === 'above' });
  }

  clickLinkHandler(anchorName) { //eslint-disable-line
    topbarAnalytics.registryAnchor(anchorName);
  }

  render() {
    const { intro, menus } = this.props;
    const modifiers = {
      fixed: this.state.fixed,
    };

    return (
      <div>
        <Waypoint onEnter={this.onCrossingTabs} onLeave={this.onCrossingTabs}/>
        <div {...bem(null, modifiers, 'toga-tabs')}>
          <div {...bem('wrapper')}>
            <img {...bem('logo', modifiers)} src={intro && intro.logo && intro.logo.url} alt=""/>
            <div {...bem('navigation', modifiers)}>
              {menus.map((menu, index) => {
                return (<Link key={index}
                              onClick={this.clickLinkHandler.bind(this, menu.label)}
                              activeClass="selected"
                              offset={-150}
                              duration={500}
                              spy={true}
                              smooth={true}
                              to={menu.role}
                              {...bem('button', modifiers)}>{menu.label}</Link>);
              })}
            </div>
          </div>
        </div>
        <div {...bem('fake', modifiers)}></div>
      </div>
    );
  }

}

export default TopModule;



// WEBPACK FOOTER //
// ./src/components/storefront/components/TopbarModule/TopbarModule.js